import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 0  // 不同小程序对接同一后台
// appid：3-维应企微SPR开发版 | 2003-维应企微SPR
// getQyLogin

// 企业微信登录 322
export function getQyLogin(data) {
    return request({
        url: "/service/qywx/qywx.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'getopenid',
            appid: 0,
            ...data
        }  //接口参数
    })
}

// 扫码登录token认证
export function checkToken(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'checkToken',
            appid: 0,
            ...data
        }  //接口参数
    })
}

// 企业微信登录获取userid 287
export function getQyChatUserId() {
    return request({
        url: "/service/qywx/login.aspx",  //接口路径
        method: "get",  //接口方法
        headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            appid
        }  //接口参数
    })
}

// 判断当前用户是否和企业微信绑定 290
export function checkUser(data) {
    return request({
        url: "/service/qywx/qywx.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'checkuser',
            appid,
            ...data
        }  //接口参数
    })
}

// 绑定用户和企业微信 291
export function getBind(data) {
    return request({
        url: "/service/qywx/qywx.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'bind',
            appid,
            ...data
        }  //接口参数
    })
}

// 取消绑定 292
export function cancelBind(data) {
    return request({
        url: "/service/qywx/qywx.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'unbind',
            appid,
            ...data
        }  //接口参数
    })
}


